import { isSyntheticCancellation } from './dataNormalizer';
import {
  normalizeEnrollmentEvidenceToken,
  resolveEnrollmentLifecycleStatus,
} from './enrollmentEvidence';

const SELECTION_COVERAGE_LIFECYCLE_STATUSES = new Set([
  'ENROLLED',
  'IN_PROGRESS',
  'ACTION_REQUIRED',
  'PENDING_PROVIDER_CHANGE',
  'OPT_OUT_PENDING',
  'PENDING',
]);

export const isSelectionCoverageEligible = (row) =>
  !isSyntheticCancellation(row) &&
  SELECTION_COVERAGE_LIFECYCLE_STATUSES.has(
    normalizeEnrollmentEvidenceToken(resolveEnrollmentLifecycleStatus(row))
  );

export { SELECTION_COVERAGE_LIFECYCLE_STATUSES };
